module.exports = "<nav *ngIf=\"router.url !== '/'\">\n  <a [routerLink]=\"'/'\">←</a>\n  <a routerLink=\"/latest-work\" [ngClass]=\"{'active' : location === 'latest-work'}\">seneste projekter</a>\n  <a [routerLink]=\"['/running']\" [ngClass]=\"{'active' : location === 'running'}\">løbetur</a>\n  <a routerLink=\"/ipsc\" [ngClass]=\"{'active' : location === 'ipsc'}\">sportsskydning</a>\n</nav>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main